import React, { useState } from "react";

import PageHeader from "./../../components/PageHeader";
import ArrowRow from "./../../components/ArrowRow";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { Images } from "../../assets/common";
import { Swap, Plus } from "react-iconly";
import ApiService from "./../../services/api-service";
import Loader from "./../../components/Loader";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { getBalance } from "../../asyncAction/asyncBalance";
import { useDispatch, useSelector } from "react-redux";
import SaveIcon from "@mui/icons-material/Save";
import LoadingButton from "@mui/lab/LoadingButton";
import {
  Box,
  Tabs,
  Tab,
  Stack,
  Slide,
  Typography,
  Button,
  OutlinedInput,
  InputAdornment,
  Divider,
} from "@mui/material";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import {
  getUsdt,
  getHbar,
  getToken,
  getWalletId,
  serialize,
  getErrorString,
  getMemo, getUserDetail,
} from "../../constants/function";
import TransactionRow from "../../components/TransactionRow";
import NoData from "../../components/Nodata";
import notifier from "../../components/Notifier";
import OffboardingBox from "../../components/OffboardingBox";
import QrPopup from "../../components/QrPopup";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LivestreamPayPopup from "../../components/LivestreamPayPopup";
import {currency} from "../../constants/common";
function BalanceBox({
  img,
  balance,
  currency,
  accountId,
  onWalletCreate,
  creating,
  notMatic,
  isHbar,
  createMatic,
  isNear,
  createNear,
  loading,
}) {
  // console.log("::accountId:-", accountId);
  return (
    <Box
      className="_flex_width"
      sx={{
        padding: "15px",
        // backgroundColor: "#262626",
        backgroundColor: "#090909",
        width: "30%",
        marginBottom: "1rem",
      }}
    >
      <Stack direction="row" gap="10px" className="_responsive_row">
        <Box>
          <img 
            style={{ height: "66px", width: "66px", objectFit: "contain" }} 
            src={img} 
            alt={currency}
            onError={(e) => {
              // Fallback to a default image if the image fails to load
              const fallbackImages = {
                hbar: require('../../assets/common/resources/Hbar.png'),
                near: require('../../assets/common/resources/Near.png'),
                matic: require('../../assets/common/resources/Polygon.png'),
                siki: require('../../assets/common/resources/siki_token.svg')
              };
              
              if (isHbar) e.target.src = fallbackImages.hbar;
              else if (isNear) e.target.src = fallbackImages.near;
              else if (!notMatic) e.target.src = fallbackImages.matic;
              else e.target.src = fallbackImages.siki;
            }}
          />
        </Box>
        {loading ? (
          <Box>
            <Box sx={{ 
              width: '150px', 
              height: '20px', 
              backgroundColor: '#333', 
              borderRadius: '4px',
              marginBottom: '8px'
            }} />
            <Box sx={{ 
              width: '100px', 
              height: '16px', 
              backgroundColor: '#333', 
              borderRadius: '4px' 
            }} />
          </Box>
        ) : !accountId && isHbar ? (
          creating && isHbar ? (
            <LoadingButton
              loading
              loadingPosition="start"
              startIcon={<SaveIcon />}
              variant="contained"
              color="primary"
            >
              Creating wallet
            </LoadingButton>
          ) : (
            <Button
              variant="contained"
              color="primary"
              onClick={() => onWalletCreate(true)}
              className="_generateButton"
            >
              Generate Wallet
            </Button>
          )
        ) : !accountId && isNear ? (
          createNear && isNear ? (
            <LoadingButton
              loading
              loadingPosition="start"
              startIcon={<SaveIcon />}
              variant="contained"
              color="primary"
            >
              Creating wallet
            </LoadingButton>
          ) : (
            <Button
              variant="contained"
              color="primary"
              onClick={() => onWalletCreate(true)}
              className="_generateButton"
            >
              Generate Wallet
            </Button>
          )
        ) : !accountId && !notMatic ? (
          createMatic && !notMatic ? (
            <LoadingButton
              loading
              loadingPosition="start"
              startIcon={<SaveIcon />}
              variant="contained"
              color="primary"
            >
              Creating wallet
            </LoadingButton>
          ) : (
            <Button
              variant="contained"
              color="primary"
              onClick={() => onWalletCreate()}
              className="_generateButton"
            >
              Generate Wallet
            </Button>
          )
        ) : (
          <Box>
            <Typography className="__logo_title">{balance}</Typography>
            <Typography variant="body2">{currency}</Typography>
            <Typography variant="body2" sx={{ wordBreak: " break-all" }}>
              {accountId}
            </Typography>
          </Box>
        )}
      </Stack>
    </Box>
  );
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: 3 }}>
          <Box>{children}</Box>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export default function Wallet() {
  const { t } = useTranslation("common");
  const swapObject = getMemo();
  const { addBalance } = useParams();
  const dispatch = useDispatch();
  const { bal, hbar, matic } = useSelector((state) => state.balance);
  const [open, setOpen] = useState(false);
  const [raiseAmount, setRaiseAmount] = useState();
  const [HBARORUDSC, setHBARORUDSC] = useState(null);
  const [message, setMessage] = useState("");
  const [transactions, setTransactions] = React.useState([]);
  const [filteredTransactions, setFilteredTransactions] = React.useState([]);
  const [transactionFilter, setTransactionFilter] = React.useState("all");
  const [myBalance, setMyBalance] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [balancesLoading, setBalancesLoading] = React.useState(true);
  const theme = useTheme();
  const [value, setValue] = React.useState(0);
  const [fundingLink, setFundLink] = useState(null);
  const [offboardingTransferType, setOffboardingTransferType] = useState(currency.SIKI);
  const [isOpenOffboardingBox, setIsOpenOffboardingBox] = useState(false);
  const [amount, setAmount] = React.useState("");
  const [pageNo, setPageNo] = React.useState(1);
  const [loaded, setLoaded] = React.useState(false);
  const [creating, setCreating] = React.useState(false);
  const [createMatic, setCreateMatic] = React.useState(false);
  const [createNear, setCreateNear] = React.useState(false);
  const [newWindow, setNewWindow] = React.useState();
  const [openPayModel, setOpenPayModel] = React.useState(false);

  const getWalletBalance = async () => {
    try {
      setBalancesLoading(true);
      const response = await ApiService.BALANCE();
      setMyBalance(response["result"]["wallets"]);
      dispatch(getBalance(response));
      setBalancesLoading(false);
    } catch (error) {
      setBalancesLoading(false);
    }
  };
  const filterTransactions = (transactionList, filter) => {
    if (filter === "all") {
      setFilteredTransactions(transactionList);
      return;
    }
    
    let filtered = [];
    switch (filter) {
      case "songRoyalties":
        filtered = transactionList.filter(t => 
          t.type === "royalty" && t.royaltyType !== "playlist"
        );
        break;
      case "playlistRoyalties":
        filtered = transactionList.filter(t => 
          t.type === "royalty" && t.royaltyType === "playlist"
        );
        break;
      case "tips":
        filtered = transactionList.filter(t => t.type === "tip");
        break;
      case "subscriptions":
        filtered = transactionList.filter(t => t.type === "subscription");
        break;
      default:
        filtered = transactionList;
    }
    setFilteredTransactions(filtered);
  };

  const handleFilterChange = (newFilter) => {
    setTransactionFilter(newFilter);
    filterTransactions(transactions, newFilter);
  };

  const getTransaction = async (next) => {
    try {
      setLoading(true);
      const response = await ApiService.TRANSACTIONS({
        pageNo: next,
        pageSize: 15,
      });
      setLoaded(response["result"].length < 15 ? true : false);
      const newTransactions = [...transactions, ...response["result"]];
      setTransactions(newTransactions);
      filterTransactions(newTransactions, transactionFilter);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    getWalletBalance();
    getTransaction(pageNo);
  }, []);

  // Initialize filtered transactions when transactions change
  React.useEffect(() => {
    if (transactions.length > 0 && filteredTransactions.length === 0 && transactionFilter === "all") {
      setFilteredTransactions(transactions);
    }
  }, [transactions]);
  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (newValue === 0) {
      getTransaction(pageNo);
    } else {
      setLoaded(false);
      setPageNo(1);
      setTransactions([]);
      setFilteredTransactions([]);
      setTransactionFilter("all");
    }
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  const raiseLimit = async () => {
    const payload = {
      status: "pending",
      reqTokenLimit: raiseAmount,
      reason: message,
    };
    setLoading(true);
    try {
      const response = await ApiService.TOKEN_LIMIT_REQUEST(payload);
      setRaiseAmount(null);
      setMessage("");
      notifier.success(t("notifier.toast1"));
      setLoading(false);
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };

  const openOffboardingBox = (transferType) => {
    setOffboardingTransferType(transferType);
    setIsOpenOffboardingBox(true);
  };
  const closeOffboardingBox = () => {
    setIsOpenOffboardingBox(false);
  };

  React.useEffect(() => {
    if (myBalance.length) {
      const tempBalance = myBalance;
      tempBalance[0]["balance"] = bal;
      setMyBalance({ ...tempBalance });
    }
  }, [bal]);
  React.useEffect(() => {
    if (addBalance && addBalance === "addBalance") setValue(1);
  }, [addBalance]);
  const handleScroll = async (target) => {
    var a = target.scrollTop;
    var b = target.scrollHeight - target.clientHeight;

    if ((a / b) * 100 > 80 && !loading && !loaded) {
      // run a function called doSomething
      const next = pageNo + 1;
      setPageNo(next);
      getTransaction(next);
    }
  };
  const createWallet = async (isHbar, isNear) => {
    try {
      const h = isHbar
        ? setCreating(true)
        : isNear
        ? setCreateNear(true)
        : setCreateMatic(true);
      const response = await ApiService.CREATE_MATIC(
        `?platform=${isHbar ? "hedera" : isNear ? "near" : "polygon"}`
      );
      setMyBalance(response["result"]["wallets"]);
      dispatch(getBalance(response));
      const b = isHbar
        ? setCreating(false)
        : createNear
        ? setCreateNear(false)
        : setCreateMatic(false);
    } catch (error) {
      setCreating(false);
      setCreateMatic(false);
      setCreateNear(false);
    }
  };

  const getPaypalLink = async (amount) => {
    if (amount >= 4.99 && amount <= 20000) {
      try {
        setLoading(true);
        const response = await ApiService.PAYPALLINK({
          amount: amount,
        });
        setLoading(false);
        setNewWindow(response["result"]["links"][1]["href"]);
        handleClosed();
      } catch (error) {
        setLoading(false);
      }
    }
  };

  const doOffboardingTransfer = async (transferType, transferAmount, walletAddress, memo) => {
      try {
        const user = getUserDetail();
        setLoading(true);
        let payload = {
          amount: transferAmount,
          email: user["email"],
          token: transferType,
          address: walletAddress,
          memo: memo
        };

        let response = "";
        switch(transferType) {
          case currency.MATIC:
          case currency.HBAR:
          case currency.NEAR:
            response = await ApiService.OFFBOARD_TRANSFER(payload);
            break;
          case currency.SIKI:
            response = await ApiService.OFFBOARD_CASHOUT(payload);
            break;
        }

        setLoading(false);
        closeOffboardingBox();
        notifier.success(response[ "result" ]);
      } catch (error) {
        setLoading(false);
        notifier.error(getErrorString(error));
      }
  };

  const redirect = () => {
    window.open(
      newWindow,
      "_blank",
      "toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500,width=400,height=400"
    );
  };

  React.useEffect(() => {
    if (newWindow) {
      redirect();
    }
  }, [newWindow]);

  const handleOpen = () => {
    setOpenPayModel(true);
  };
  const handleClosed = () => {
    setOpenPayModel(false);
  };


  return (
    <Box id="walletBox">
      <Box sx={{ padding: "0 18px 32px 18px", position: "relative" }}>
        {/* {myBalance?._id ? ( */}
        <Stack direction="row" gap="24px" className="responsive-flex">
          <BalanceBox
            img={Images.tip_player}
            currency={`${t("wallet.text3")} SIKI Token`}
            balance={
              myBalance[0]?.balance
                ? myBalance[0]["balance"].toFixed(2)
                : "0.00"
            }
            notMatic={true}
            loading={balancesLoading}
            // accountId={myBalance.length && myBalance[0]["walletAddress"]}
          />
          <BalanceBox
            img={myBalance[2]?.platformImg || Images.hbar_balance}
            currency={`${t("wallet.text3")} HBar`}
            balance={
              myBalance[2]?.balance
                ? myBalance[2]["balance"].toFixed(2)
                : "0.00"
            }
            accountId={myBalance[2]?.walletAddress}
            isHbar={true}
            onWalletCreate={(isHbar) => createWallet(isHbar)}
            creating={creating}
            loading={balancesLoading}
          />
          <BalanceBox
            img={myBalance[1]?.platformImg || Images.polygon_balance}
            currency={`${t("wallet.text3")} MATIC`}
            balance={
              myBalance[1]?.balance
                ? myBalance[1]["balance"].toFixed(2)
                : "0.00"
            }
            accountId={myBalance[1]?.walletAddress}
            onWalletCreate={() => createWallet()}
            createMatic={createMatic}
            loading={balancesLoading}
          />
          <BalanceBox
            img={myBalance[3]?.platformImg || Images.near_shadow}
            currency={`${t("wallet.text3")} NEAR`}
            balance={
              myBalance[3]?.balance
                ? myBalance[3]["balance"].toFixed(2)
                : "0.00"
            }
            isNear={true}
            accountId={myBalance[3]?.walletAddress}
            onWalletCreate={(isNear) => createWallet(false, isNear)}
            createNear={createNear}
            loading={balancesLoading}
          />
        </Stack>
        {/* ) : (
          <Stack sx={{ height: "150px", position: "relative" }}>
            <Loader
              labalce={true}
              _class="__loader_inside"
              message={t("wallet.loader")}
            />
          </Stack>
        )} */}

        <hr style={{ borderColor: "#404040" }} />
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          aria-label="full width tabs example"
        >
          <Tab id="tabShowTransactionHistory"
            className="responsive-flex"
            sx={{ display: "flex", flexDirection: "row", gap: "5px" }}
            icon={
              <img
                src={value === 0 ? Images.transction1 : Images.transction}
                alt="Add"
              />
            }
            label={t("wallet.tab1")}
            {...a11yProps(0)}
          />
          <Tab id="tabAddSikiTokens"
            className="responsive-flex"
            sx={{ display: "flex", flexDirection: "row", gap: "5px" }}
            icon={
              <img
                src={value === 1 ? Images.add_siki_coin1 : Images.add_siki_coin}
                alt="Add"
              />
            }
            label={t("wallet.tab2")}
            {...a11yProps(1)}
          />
          <Tab id="tabRaiseMonthlySpend"
            className="responsive-flex"
            sx={{ display: "flex", flexDirection: "row", gap: "5px" }}
            icon={
              <ArrowUpwardIcon
                sx={{ transform: "rotate(45deg)" }}
                color={value === 2 ? "primary" : "default"}
              />
            }
            label={t("wallet.tab3")}
            {...a11yProps(1)}
          />
          <Tab id="tabOffboarding"
               className="responsive-flex"
               sx={{ display: "flex", flexDirection: "row", gap: "5px" }}
               icon={
                 <ArrowUpwardIcon
                   sx={{ transform: "rotate(45deg)" }}
                   color={value === 2 ? "primary" : "default"}
                 />
               }
               label={t("wallet.tab4")}
               {...a11yProps(1)}
          />
        </Tabs>
        <Box
          axis={theme.direction === "rtl" ? "x-reverse" : "x"}
          index={value}
          sx={{ maxHeight: "77vh", overflow: "scroll" }}
        >
          <TabPanel value={value} index={0} dir={theme.direction}>
            <Box className="__main_pading">
              <Stack spacing={1} sx={{ position: "relative" }}>
                {/* Transaction Filter Tabs */}
                <Box sx={{ 
                  display: 'flex', 
                  gap: 1, 
                  mb: 2, 
                  flexWrap: 'wrap',
                  borderBottom: '1px solid #404040',
                  pb: 2
                }}>
                  <Button
                    variant={transactionFilter === "all" ? "contained" : "outlined"}
                    size="small"
                    onClick={() => handleFilterChange("all")}
                    sx={{ 
                      borderRadius: '20px',
                      textTransform: 'none',
                      minWidth: 'auto',
                      px: 2
                    }}
                  >
                    All
                  </Button>
                  <Button
                    variant={transactionFilter === "songRoyalties" ? "contained" : "outlined"}
                    size="small"
                    onClick={() => handleFilterChange("songRoyalties")}
                    sx={{ 
                      borderRadius: '20px',
                      textTransform: 'none',
                      minWidth: 'auto',
                      px: 2
                    }}
                  >
                    Song Royalties
                  </Button>
                  <Button
                    variant={transactionFilter === "playlistRoyalties" ? "contained" : "outlined"}
                    size="small"
                    onClick={() => handleFilterChange("playlistRoyalties")}
                    sx={{ 
                      borderRadius: '20px',
                      textTransform: 'none',
                      minWidth: 'auto',
                      px: 2
                    }}
                  >
                    Playlist Royalties
                  </Button>
                  <Button
                    variant={transactionFilter === "tips" ? "contained" : "outlined"}
                    size="small"
                    onClick={() => handleFilterChange("tips")}
                    sx={{ 
                      borderRadius: '20px',
                      textTransform: 'none',
                      minWidth: 'auto',
                      px: 2
                    }}
                  >
                    Tips
                  </Button>
                  <Button
                    variant={transactionFilter === "subscriptions" ? "contained" : "outlined"}
                    size="small"
                    onClick={() => handleFilterChange("subscriptions")}
                    sx={{ 
                      borderRadius: '20px',
                      textTransform: 'none',
                      minWidth: 'auto',
                      px: 2
                    }}
                  >
                    Subscriptions
                  </Button>
                </Box>
                
                <Stack
                  onScroll={(e) => handleScroll(e.target)}
                  spacing={2}
                  sx={{ maxHeight: "73vh", overflow: "scroll" }}
                >
                  {filteredTransactions.length > 0 ? (
                    filteredTransactions.map((transaction, index) => (
                      <TransactionRow key={index} transaction={transaction} />
                    ))
                  ) : (
                    <NoData lable={t("noData.message20")} />
                  )}
                </Stack>
              </Stack>
            </Box>
          </TabPanel>
          <TabPanel value={value} index={1} dir={theme.direction}>
            <Stack spacing={2} className="__main_pading __add_balance_tab">
              <Stack id="stackSwapHbarToSiki"
                onClick={() => {
                  // if (myBalance?.accountId === "" || !myBalance?.accountId)
                  if (
                    myBalance[2]?.walletAddress === "" ||
                    !myBalance[2]?.walletAddress
                  )
                    notifier.error(t("openWallet"));
                  else {
                    setHBARORUDSC("hbar");
                    setOpen(true);
                  }
                }}
                className="__balance_row"
                direction="row"
                justifyContent="space-between"
              >
                <Typography>{t("wallet.text4")}</Typography>
                <img className="transform180" src={Images.back} alt="back" />
              </Stack>
              {/* <Stack
                onClick={() => {
                  setHBARORUDSC("udsc");
                  setOpen(true);
                }}
                className="__balance_row"
                direction="row"
                justifyContent="space-between"
              >
                <Typography>Swap USDC-Polygon to SIKI</Typography>
                <img className="transform180" src={Images.back} alt="back" />
              </Stack> */}

              <Stack id="stackPaypalToSiki"
                onClick={() => {
                  // if (myBalance?.accountId === "" || !myBalance?.accountId)
                  if (
                    myBalance[2]?.walletAddress === "" ||
                    !myBalance[2]?.walletAddress
                  )
                    notifier.error(t("openWallet"));
                  else handleOpen();
                }}
                className="__balance_row"
                direction="row"
                justifyContent="space-between"
              >
                <Typography>{t("wallet.text6")}</Typography>
                <img className="transform180" src={Images.back} alt="back" />
              </Stack>

            </Stack>
          </TabPanel>
          <TabPanel value={value} index={2} dir={theme.direction}>
            <Box
              className="__main_pading"
              sx={{ maxWidth: "375px", margin: "auto" }}
            >
              <Stack>
                <Typography className="fs-14">
                  {t("wallet.input1.label")}
                </Typography>
                <OutlinedInput
                  type="number"
                  value={raiseAmount}
                  onChange={(e) => setRaiseAmount(e.target.value)}
                  placeholder={t("wallet.input1.placeholder")}
                  sx={{
                    marginTop: "5px",
                    // backgroundColor: "#262626",
                    backgroundColor: "#171515",
                    border: "0px !important",
                    height: "50px",
                  }}
                  endAdornment={
                    <InputAdornment
                      sx={{ fontSize: "13px !important" }}
                      position="end"
                    >
                      {t("wallet.input1.helper")}
                    </InputAdornment>
                  }
                />
                <Typography className="fs-14 mt-5">
                  {t("wallet.input2.label")}
                </Typography>
                <OutlinedInput
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder={t("wallet.input2.placeholder")}
                  multiline
                  sx={{
                    marginTop: "5px",
                    // backgroundColor: "#262626",
                    backgroundColor: "#171515",

                    border: "0px !important",
                    height: "101px",
                  }}
                />

                <Button
                  className="mt-10"
                  onClick={() => raiseLimit()}
                  sx={{ width: "100% !important", height: "50px" }}
                  variant="contained"
                  color="primary"
                  disabled={!raiseAmount || !message}
                >
                  {t("wallet.button")}
                </Button>
              </Stack>
            </Box>
          </TabPanel>
          <TabPanel value={value} index={3} dir={theme.direction}>
            <Stack spacing={2} className="__main_pading __add_balance_tab">

              <Stack id="stackPolygonTokenTransfer"
                     onClick={() => {
                       if ( myBalance[1]?.walletAddress === "" || !myBalance[1]?.walletAddress )
                         notifier.error(t("openWallet") + " - " + myBalance[1]?.walletAddress );
                       else openOffboardingBox(currency.MATIC);
                     }}
                     className="__balance_row"
                     direction="row"
                     justifyContent="space-between"
              >
                <Typography>{t("wallet.txtPolygonTokenTransfer")}</Typography>
                <img className="transform180" src={Images.back} alt="back" />
              </Stack>

              <Stack id="stackHbarTokenTransfer"
                     onClick={() => {
                       if ( myBalance[2]?.walletAddress === "" || !myBalance[2]?.walletAddress )
                         notifier.error(t("openWallet") + " - " + myBalance[2]?.walletAddress );
                       else openOffboardingBox(currency.HBAR);
                     }}
                     className="__balance_row"
                     direction="row"
                     justifyContent="space-between"
              >
                <Typography>{t("wallet.txtHbarTokenTransfer")}</Typography>
                <img className="transform180" src={Images.back} alt="back" />
              </Stack>

              <Stack id="stackNearTokenTransfer"
                     onClick={() => {
                       if ( myBalance[3]?.walletAddress === "" || !myBalance[3]?.walletAddress )
                         notifier.error(t("openWallet") + " - " + myBalance[3]?.walletAddress );
                       else openOffboardingBox(currency.NEAR);
                     }}
                     className="__balance_row"
                     direction="row"
                     justifyContent="space-between"
              >
                <Typography>{t("wallet.txtNearTokenTransfer")}</Typography>
                <img className="transform180" src={Images.back} alt="back" />
              </Stack>

              <Stack id="stackSikiCashout"
                     onClick={() => {
                       if ( myBalance[0]?.walletAddress === "" || !myBalance[0]?.walletAddress )
                         notifier.error(t("openWallet") + " - " + myBalance[0]?.walletAddress );
                       else openOffboardingBox(currency.SIKI);
                     }}
                     className="__balance_row"
                     direction="row"
                     justifyContent="space-between"
              >
                <Typography>{t("wallet.txtSikiCashout")}</Typography>
                <img className="transform180" src={Images.back} alt="back" />
              </Stack>
            </Stack>

          </TabPanel>
        </Box>
      </Box>
      {loading ? <Loader /> : null}

      <OffboardingBox
        transferType={offboardingTransferType}
        open={isOpenOffboardingBox}
        handleClose={closeOffboardingBox}
        handleSubmit={(amount,walletAddress,memo) => {
          doOffboardingTransfer(offboardingTransferType,amount,walletAddress,memo);
        }}
        loading={loading}
      />
      <LivestreamPayPopup
        open={openPayModel}
        handleClose={handleClosed}
        handleSubmit={(amount, type) => {
          getPaypalLink(amount);
        }}
        loading={loading}
        onlyPayPal={true}
      />
      {open ? (
        <QrPopup
          open={open}
          handleClose={() => setOpen(false)}
          params={{ walletId: swapObject, hbar: getHbar(), usdc: getUsdt() }}
          value={HBARORUDSC}
        />
      ) : null}
    </Box>
  );
}
